
import { Injectable, Inject} from '@angular/core';
import {BaseDO} from './base.model';

import {BulkProcessDetailDO} from './BulkProcessDetail.model';

 export  class IntBulkProcLogDO extends BaseDO {

    public id:Number=null;
    public  batchId:string=null;
    public  batchRefId:string=null;
    public  templateFileFormat:string=null;
    public  templateFileName:string=null;
    public  totalIntimation:Number=null;
    public  successfulIntimation:Number=null;
    public  failedIntimations:Number=null;
    public  batchStatusCd:string=null;
   

    //public bulkPolicyDtlList:BulkProcessDetailDO[]=[];

    
 }